import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import device from '@deprecated-ui/_style/device';

export const DetailContainer = styled.div`
  background: #FFFFFF;
  border: 1px solid #DADADA;
  border-radius: 4px;
`;

export const MyInvestmentWrapper = styled.div`
  padding: 10px;

  @media ${device.tablet} {
    padding: 20px;
  }
`;

export const MyInvestmentContainer = styled(Flex)`
  background: #EBF8F3;
  padding: 16px;
  width: 100%;
  border-radius: 4px;
  justify-content: space-between;
`;

export const MyInvestmentItemContainer = styled(Flex).attrs({
  align: 'center',
})`
  gap: 10px;

  #my-investment-symbol {
    display: none;
  }

  .my-investment-item > div {
    display: block;
    p > {
      margin-left: 0;
    }
  }

  @media ${device.tablet} {
    gap: 32px;

    #my-investment-symbol {
      display: flex;
    }

    .my-investment-item > div {
      display: flex;
      p > {
        margin-left: 8px;
      }
    }
  }
`;

export const ContentContainer = styled.div`
  padding: 16px;
  border-top: 1px solid #DADADA;
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));

  @media ${device.tablet} {
    padding: 20px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const CouponDetailItemContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  justify-content: space-between;

  @media ${device.tablet} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  > div:first-child {
    margin-bottom: 7px;

    @media ${device.tablet} {
      margin-bottom: 0;
    }
  }
`;

export const ContentContainerLeft = styled.div`
  padding-right: 0;
  padding-left: 0;
  border-right: unset;
  

  ${CouponDetailItemContainer} {
    padding-bottom: 12px;
    padding-top: 12px;
    border-bottom: 1px solid #EDEDED;

    @media ${device.tablet} {
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }

  @media ${device.tablet} {
    border-right: 1px solid #DADADA;
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const AboutItemContainer = styled.div``;

export const ContentContainerRight = styled.div`
  margin: 20px 0 0 0;

  ${AboutItemContainer} {
    padding: 12px 0 12px 0;
    border-bottom: 1px solid #EDEDED;

    :last-child {
      border-bottom: unset;
    }

    @media ${device.tablet} {
      padding: 16px 0 16px 0;
    }
  }

  @media ${device.tablet} {
    margin: 0 20px 0 20px;
  }
`;

export const MyInvestmentMenuButton = styled.div`
  cursor: pointer;
`;

export const MyInvestmentMenuDropdown = styled.div`
  background: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #DADADA;
  padding: 8px 16px;

  > * {
    cursor: pointer;
  }
`;
